import type { IScope } from "angular";
import { cloneDeep, isEmpty } from "lodash";

import type { IDataRetention, IResponseWithLoading } from "App/Modules/Models";
import type { IPartnersRepository } from "App/Modules/Repositories";
import type { IFormContainerResolve } from "App/Modules/Services";
import { PatchDelta } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";

export default class EditDataRetentionSettingsComponentController {
    public static $inject: string[] = ["$scope", "mmPartnersRepository"];

    public partnerId: string;

    public original: IDataRetention;

    public edited: IDataRetention;

    public isNew: boolean;

    public resolve: IFormContainerResolve<IDataRetention, string>;

    public editResponse: IResponseWithLoading<IDataRetention>;

    constructor(private readonly $scope: IScope, private readonly partnersRepository: IPartnersRepository) {}

    public $onInit() {
        this.isNew = isEmpty(this.resolve.formData);
        this.partnerId = this.resolve.bindings;
        this.original =
            this.resolve.formData ||
            ({
                maxDaysCameraImages: null,
                maxDaysOtherAlarmVideo: null,
                maxDaysRecordedVideo: null,
                maxDaysSharpAlarmVideo: null,
            } as IDataRetention);
        this.edited = cloneDeep(this.original);
    }

    public cancel() {
        if (this.resolve.options.onCancel) {
            this.resolve.options.onCancel();
        }
    }

    public editDataRetentionSettings() {
        const delta = PatchDelta.difference(this.original, this.edited);
        const observable = this.isNew
            ? this.partnersRepository.addDataRetention(this.partnerId, this.edited)
            : this.partnersRepository.patchDataRetention(this.partnerId, this.original.id, delta);

        if (!isEmpty(delta) || this.isNew) {
            extendWithLoadingAndFail(observable).subscribe(
                (response: IResponseWithLoading<IDataRetention>) => {
                    this.editResponse = response;
                    if (!response.isLoading && response.data) {
                        this.edited = response.data;
                        this.resolve.options.onOk(response.data);
                    }
                },
                (error: IResponseWithLoading<null>) => {
                    this.editResponse = error;
                },
            );
        } else {
            this.cancel();
        }
    }
}
